import { NbMenuItem } from "@nebular/theme";
import { ContentEnum, GridCell, RowCell, ContentElement } from "@urbannex/storethemes";
/**
 * SectionEditContext enum is used with the main menu to determine which template option to load
 * Options are layout, background,
 * text,
 * image,
 * theme
 */

export enum SectionEditContext {
  TEXT = "text",
  BACKGROUND = "background",
  LAYOUT = "layout",
  THEME = "theme",
  IMAGE = "image"
}

export interface CellEditCtx {
  cellId: string;
  contentEnum?: ContentEnum;
  cell: GridCell | RowCell;
}

export interface ContentElementCtx {
  elId: string;
  contentElement: ContentElement,
  cellId?: string
}
export const mainMenuItems: NbMenuItem[] = [
  /* {
    title:"Text Color",
    link:"#",
    icon:{icon:"text-color",pack:"custom-icons"},
    data:{
      context:SectionEditContext.TEXT
    }
  },{
    title:"Background",
    link:"#",
    icon:{icon:"paint",pack:"custom-icons"},
    data:{
      context:SectionEditContext.BACKGROUND
    }
  },{
    title:"Layout",
    link:"#",
    icon:{icon:"layout-outline",pack:"eva"},
    data:{
      context:SectionEditContext.LAYOUT
    }
  },{
    title:"Theme",
    link:"#",
    icon:{icon:"color-palette-outline",pack:"eva"},
    data:{
      context:SectionEditContext.THEME
    }
  },{
    title:"Image",
    link:"#",
    icon:{icon:"image-outline",pack:"eva"},
    data:{
      context:SectionEditContext.IMAGE
    }
  } */
]

export const editMenuItems: NbMenuItem[] = [
  {
    title: "Font",
    icon: { "icon": "font-menu", pack: 'custom-icons' },
    group: true
  },
  {
    title: "Header Size",
    icon: { "icon": "header-size", pack: "custom-icons" }
  },
  {
    title: "Font Size",
    icon: { "icon": "font-size", pack: "custom-icons" }
  },
  {
    title: "Font Weight",
    icon: { "icon": "font-weight", pack: "custom-icons" }
  },
  {
    title: "Font Family",
    icon: { "icon": "font-family", pack: "custom-icons" }
  },
  {
    title: "Underline",
    icon: { "icon": "underline", pack: "custom-icons" }
  },
  {
    title: "Italic",
    icon: { "icon": "italic", pack: "custom-icons" }
  },
  {
    title: "Font Color",
    icon: { "icon": "fill-color", pack: 'custom-icons' }
  },
  {
    title: "Align",
    icon: { "icon": "align-menu", pack: 'custom-icons' },
    group: true
  },
  {
    title: "Align bottom",
    icon: { "icon": "align-bottom", pack: "custom-icons" }
  },
  {
    title: "Align-middle",
    icon: { "icon": "align-middle", pack: "custom-icons" }
  },
  {
    title: "Align-top",
    icon: { "icon": "align-top", pack: "custom-icons" }
  },
  {
    title: "Align-left",
    icon: { "icon": "align-left", pack: "custom-icons" }
  },
  {
    title: "Align-center",
    icon: { "icon": "align-center", pack: "custom-icons" }
  },
  {
    title: "Align-right",
    icon: { "icon": "align-right", pack: "custom-icons" }
  }
]
